import { getFragment } from '../../graphql/client/helpers/get-fragment';
import type { MedicationConfigOverride } from '../../hooks/use-config-api';
import type { PrescriptionOffer } from '../../hooks/use-prescription-offers';
import { processProviderToPharmacyInfo } from '../pharmacy';

export const sortOffersByPharmacyName =
    (configOverride: MedicationConfigOverride) =>
    (a: PrescriptionOffer, b: PrescriptionOffer) => {
        const nameA =
            processProviderToPharmacyInfo(
                getFragment(a.provider),
                configOverride
            )?.name ?? '';
        const nameB =
            processProviderToPharmacyInfo(
                getFragment(b.provider),
                configOverride
            )?.name ?? '';

        return nameA.localeCompare(nameB);
    };
